import { Box } from '@mui/material'
import { observer } from 'mobx-react'
import React, { FC } from 'react'
import { useLocation } from 'react-router'
import NewFilters from '../../../../components/NewFilters/NewFilters'
import { getImageSrc } from '../../../../helpers/getImageSrc'
import { requestFilters } from '../../../../helpers/getRequestsFilters'
import { isAdmin, isDealer } from '../../../../services/AccountService'
import { PaginationStoreType } from '../../../../stores/NewPaginationStore'
import { getStyles } from '../../../../utils/utils/commonUtils'
import { getComp } from '../../../../utils/utils/DI'
import { RequestsTabType } from '../../../Service/components/AdminTables/stores/AdminServiceTablesStore'
import paramsFilterStore from '../../../SummaryStatisticsDealers/store/ParamsFilterStore'
import requestFiltersStyles from '../../styles/requestFiltersStyles'
import { useRequestsTableFilters } from './hooks/useRequestsTableFilters'
import { RequestsTableFilterStoreType } from './stores/RequestsTableFilterStore'
import { RequestTableParamsType } from './types/new-requests-table.types'

interface RequestsTableFiltersProps {
  paginationStore: PaginationStoreType<RequestTableParamsType>
  filtersStore: RequestsTableFilterStoreType
  checkboxStore: any
  tab?: RequestsTabType
}

const RequestsTableFilters: FC<RequestsTableFiltersProps> = ({
  paginationStore,
  filtersStore,
  checkboxStore,
  tab,
}) => {
  const classes = getStyles(requestFiltersStyles)
  const { pathname } = useLocation()

  const { actionButtonProps, data, intl, onSearch, setChip } =
    useRequestsTableFilters(paginationStore, filtersStore)

  return (
    <Box>
      {/* @ts-ignore */}
      <NewFilters
        title={intl.formatMessage(
          {
            id: 'Найдено заявок {reports}',
            defaultMessage: 'Найдено заявок {reports}',
          },
          {
            reports: data?.totalSize ?? 0,
          },
        )}
        setChip={setChip}
        totalCollectionLength={data?.totalSize ?? 0}
        filtersStore={filtersStore}
        filtersData={getFiltersData(intl, pathname, classes, filtersStore, tab)}
        onSearch={onSearch}
        filtersContainerHeight={'150px'}
        actionButtonProps={actionButtonProps}
        disableProgress={true}
        paginationStore={paginationStore}
        checkboxStore={checkboxStore}
      />
    </Box>
  )
}
const getFiltersData = (
  intl: any,
  currentPath: any,
  classes: any,
  filtersStore: any,
  tab?: RequestsTabType,
) => {
  if (isAdmin())
    return getAdminFiltersData(intl, currentPath, classes, filtersStore)
  else if (isDealer())
    return getDealerFiltersData(intl, currentPath, classes, filtersStore, tab)
}

const getAdminFiltersData = (
  intl: any,
  currentPath: any,
  classes: any,
  filtersStore: any,
) => [
  [
    requestFilters.statuses(intl, currentPath, paramsFilterStore, classes),
    requestFilters.dataCheckingStatus(
      intl,
      getComp('StatusesStore').getDataCheckingStatuses({
        dealerReportsFilters: false,
      }),
    ),
    [requestFilters.id(intl), requestFilters.phone(intl)],
    [requestFilters.surnamePartial(intl), requestFilters.namePartial(intl)],
    requestFilters.fullName(intl),
    requestFilters.territory(intl),
    requestFilters.district(intl, filtersStore),
    requestFilters.locality(intl, filtersStore),
    requestFilters.address(intl),
    requestFilters.priorities(intl),
    requestFilters.financialSourceIds(intl),
    [requestFilters.from(intl), requestFilters.to(intl)],
    requestFilters.source(intl),
    requestFilters.authorId(intl),
  ],
  [
    requestFilters.reason(intl),
    requestFilters.reasonId(intl),
    requestFilters.sender(intl),
    requestFilters.senderGroupIds(intl),

    [
      requestFilters.installedFrom(intl, null),
      requestFilters.installedTo(intl, null),
    ],
    requestFilters.dealerIds(intl, classes, getImageSrc('dealer')),
    requestFilters.equipmentId(intl),
    requestFilters.preferentialCategory(intl),
    requestFilters.categories(intl),
    requestFilters.isDangerous(intl),
    requestFilters.hasDuplicates(intl),
    requestFilters.isExpired(intl, getImageSrc('isExpiredAssign')),
    requestFilters.isSuspicious(intl, getImageSrc('isSuspicious')),
  ],
]

const getDealerFiltersData = (
  intl: any,
  currentPath: any,
  classes: any,
  filtersStore: any,
  tab?: RequestsTabType,
) => [
  [
    requestFilters.statuses(intl, currentPath, paramsFilterStore, classes, tab),
    requestFilters.dataCheckingStatus(
      intl,
      getComp('StatusesStore').getDataCheckingStatuses({
        dealerReportsFilters: false,
      }),
    ),
    [requestFilters.id(intl), requestFilters.phone(intl)],
    [requestFilters.surnamePartial(intl), requestFilters.namePartial(intl)],
    requestFilters.fullName(intl),
    requestFilters.territory(intl),
    requestFilters.district(intl, filtersStore),
    requestFilters.locality(intl, filtersStore),
    requestFilters.address(intl),
    requestFilters.financialSourceIds(intl),
    [requestFilters.from(intl), requestFilters.to(intl)],
    [
      requestFilters.installedFrom(intl, null),
      requestFilters.installedTo(intl, null),
    ],
  ],
  [
    requestFilters.reasonId(intl),
    requestFilters.sender(intl),
    requestFilters.senderGroupIds(intl),
    requestFilters.equipmentId(intl),
    requestFilters.categories(intl),
    requestFilters.isDangerous(intl),
    requestFilters.hasDuplicates(intl),
    requestFilters.isExpired(intl, getImageSrc('isExpiredAssign')),
  ],
]

export default observer(RequestsTableFilters)
